import {
    Image,
    Position,
    Size,
    BackgroundField,
    Properties
} from "../../styles";

export function mockBackgroundField({
    breakpoints = ["xs", "sm", "md", "lg", "xl"],
    color = "transparent",
    properties = []
}: Partial<BackgroundField> = {}): BackgroundField {
    return {
        breakpoints,
        color,
        properties
    };
}

export function mockProperties({
    attachment = "scroll",
    blendMode = "normal",
    clip = "border-box",
    image = mockImage(),
    origin = "padding-box",
    position = mockPosition(),
    repeat = "repeat",
    size = mockSize()
}: Partial<Properties> = {}): Properties {
    return {
        attachment,
        blendMode,
        clip,
        image,
        origin,
        position,
        repeat,
        size
    };
}

export function mockImage({
    type = "gradient",
    image = mockImageImage(),
    gradient = mockImageGradient()
}: Partial<Image> = {}): Image {
    return {
        type,
        image,
        gradient
    };
}

export function mockImageImage({
    id = "",
    value = "none"
}: Partial<Image["image"]> = {}): Image["image"] {
    return {
        id,
        value
    };
}

export function mockImageGradient({
    value = "none",
    angle = 0
}: Partial<Image["gradient"]> = {}): Image["gradient"] {
    return {
        value,
        angle
    };
}

export function mockPosition({
    fieldType = "units",
    keywords = mockPositionKeywords(),
    units = mockPositionUnits()
}: Partial<Position> = {}): Position {
    return {
        fieldType,
        keywords,
        units
    };
}

export function mockPositionKeywords({
    horizontal = "left",
    vertical = "top"
}: Partial<Position["keywords"]> = {}): Position["keywords"] {
    return {
        horizontal,
        vertical
    };
}

export function mockPositionUnits({
    unit = "%",
    horizontal = 0,
    vertical = 0
}: Partial<Position["units"]> = {}): Position["units"] {
    return {
        unit,
        horizontal,
        vertical
    };
}

export function mockSize({
    fieldType = "units",
    keyword = "auto",
    units = mockSizeUnits()
}: Partial<Size> = {}): Size {
    return {
        fieldType,
        keyword,
        units
    };
}

export function mockSizeUnits({
    unit = "%",
    width = 100,
    height = 100,
    isAutoWidth = false,
    isAutoHeight = false
}: Partial<Size["units"]> = {}): Size["units"] {
    return {
        unit,
        width,
        height,
        isAutoWidth,
        isAutoHeight
    };
}
